<template>
  <div>
     <div v-if="activeTab==='landingPage'">
    <v-toolbar flat color="white" pt-4 mt-4>
      <v-btn round color="primary" @click="addItem()">Add Order</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search"></v-text-field>
    </v-toolbar>
    <v-toolbar flat color="white">
      <v-tabs div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
          >{{ tab.displayName }}</v-tab
        >
      </v-tabs>
    </v-toolbar>
     <div v-if="displayContents('openOrders')"> 
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="
          stockorders.filter(function (el) {
            return el.isProcessed === false;
          })
        "
        :search="search"
        item-key="id"
        align-center
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <!-- <v-icon @click="editItem(props.item)">edit</v-icon> -->
            <v-icon @click="deleteItem(props.item)">delete</v-icon>
          </td>
          <td class="text-xs-center" @click="editItem(props.item)">
            {{ formatDate(props.item.orderDate) }}
          </td>
          <td class="text-xs-center" @click="editItem(props.item)">
            {{ formatDate(props.item.expectedArrivalDate) }}
          </td>
          <td class="text-xs-center" @click="editItem(props.item)">
            {{ props.item.supplierOrganisation.name }}
          </td>
          <td class="text-xs-center" @click="editItem(props.item)">
            {{ props.item.purchaseOrderNo }}
          </td>
          <td class="text-xs-center" @click="editItem(props.item)">
            {{ props.item.courier }}
          </td>
          <td class="text-xs-center" @click="editItem(props.item)">
            {{ props.item.trackingNo }}
          </td>
          <td class="text-xs-center" @click="editItem(props.item)">
            <v-chip
              color="light-green"
              v-if="props.item.orderStatus === 'Delivered'"
              class="white--text"
              >Delivered</v-chip
            >
            <v-chip
              color="orange"
              v-else-if="props.item.orderStatus === 'InTransit'"
              class="white--text"
              >In Transit</v-chip
            >
            <v-chip
              color="orange"
              v-else-if="props.item.orderStatus === 'Pending'"
              class="white--text"
              >Pending</v-chip
            >
            <v-chip
              color="red"
              v-else-if="props.item.orderStatus === 'Exception'"
              class="white--text"
              >Exception</v-chip
            >
            <v-chip
              color="red"
              v-else-if="props.item.orderStatus === 'FailAttempt'"
              class="white--text"
              >Failed Attempt</v-chip
            >
            <span v-else></span>
          </td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}</template
        >
      </v-data-table>
     </div>

      <div v-if="displayContents('processedOrders')">
      <v-data-table
        :headers="processedHeaders"
        class="elevation-1"
        :items="
          stockorders.filter(function (el) {
            return el.isProcessed === true;
          })
        "
        :search="search"
        item-key="id"
        align-center
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          <td class="text-xs-center" @click="viewItem(props.item)">
            {{ formatDate(props.item.orderDate) }}
          </td>
          <td class="text-xs-center" @click="viewItem(props.item)">
            {{ formatDate(props.item.expectedArrivalDate) }}
          </td>
          <td class="text-xs-center" @click="viewItem(props.item)">
            {{ formatDate(props.item.checkInDate) }}
          </td>
          <td class="text-xs-center" @click="viewItem(props.item)">
            {{ props.item.supplierOrganisation.name }}
          </td>
          <td class="text-xs-center" @click="viewItem(props.item)">
            {{ props.item.purchaseOrderNo }}
          </td>
          <td class="text-xs-center" @click="viewItem(props.item)">
            {{ props.item.courier }}
          </td>
          <td class="text-xs-center" @click="viewItem(props.item)">
            {{ props.item.trackingNo }}
          </td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}</template
        >
      </v-data-table>

    
    </div>
    </div>
  <div v-if="activeTab==='viewProcessedOrderModal'">
          <v-toolbar flat color="white">
                 <h1  v-if="item.supplierOrganisation"
              :style="{ color: $store.state.currentOrg.org.primaryColour}">
              VIEW PROCESSED ORDER:
              <span
                >{{ item.supplierOrganisation.name }}
                {{ item.purchaseOrderNo }}</span
              >
            </h1>
                <v-spacer></v-spacer>
                <v-btn flat @click="activeTab='landingPage', setActiveTabName('openOrders')">Close</v-btn>
            </v-toolbar>
            <v-layout align-top justify-center> 
              <v-flex xs12>
        <v-card flat color="white">
          <v-layout justify-center mt-3>
            <v-flex xs6 mx-1>
              <v-card>
                <v-toolbar color="primary" flat>
                  <h3 class="headline white--text">Checked-In Items:</h3>
                </v-toolbar>
                <v-card>
                  <!-- <v-toolbar color="primary">
                  <h3 class="subheading white--text" >Order Items:</h3>
                  <v-spacer></v-spacer>
                  <v-btn flat @click="addOrderItem=true"><v-icon color="white">add_circle_outline</v-icon></v-btn>
                </v-toolbar> -->
                  <v-card-text :key="stockOrderListKey">
                    <v-flex
                      xs12
                      v-if="
                        typeof item.stockOrderItems === 'undefined' ||
                        item.stockOrderItems.length === 0
                      "
                    >
                      <h3 class="grey--text font-weight-light">
                        No Order Items Added.
                      </h3>
                    </v-flex>
                    <v-flex
                      xs12
                      my-1
                      v-for="order in item.stockOrderItems"
                      :key="order.stockItemId || order.viewMore"
                    >
                      <!-- <v-flex xs12> -->
                      <v-card
                        hover
                        @click="
                          checkinHistory(order.id), (selectedItem = order)
                        "
                        v-if="selectedItem === order"
                        color="grey lighten-2"
                      >
                        <v-layout justify-left align-center wrap>
                          <v-flex xs3>
                            <v-layout justify-center align-center row>
                              <v-flex xs2 ml-2 mr-1
                                ><h3 class="grey--text font-weight-light">
                                  <span
                                    v-if="
                                      order.checkedinCount >= order.quantity
                                    "
                                    class="green--text"
                                    >{{ order.checkedinCount }}</span
                                  ><span v-else class="red--text">{{
                                    order.checkedinCount
                                  }}</span
                                  >/{{ order.quantity }}
                                </h3></v-flex
                              >
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs3
                            v-if="
                              order.type === 'Active' &&
                              order.deviceMakeModel !== null
                            "
                          >
                            <h3 class="grey--text font-weight-light">
                              {{ order.deviceMakeModel.deviceMake.name }}
                              {{ order.deviceMakeModel.name }}
                            </h3>
                          </v-flex>
                          <v-flex
                            xs3
                            v-else-if="
                              order.type === 'Passive' &&
                              order.stockType !== null &&
                              order.stockItemId !== null
                            "
                            ><h3 class="grey--text font-weight-light">
                              {{ order.stockType.name }}
                              {{ order.stockItem.name }}
                            </h3></v-flex
                          >
                          <v-flex xs4>
                            <v-layout justify-center>
                              <v-flex xs6 v-if="order.priceUSD > 0">
                                <h3 class="grey--text">USD</h3>
                                <h4 class="grey--text font-weight-light">
                                  Unit: ${{ order.priceUSD }}
                                </h4>
                                <h4 class="grey--text font-weight-light">
                                  Total: ${{ order.priceUSD * order.quantity }}
                                </h4>
                              </v-flex>
                              <v-flex xs6>
                                <h3 class="grey--text">ZAR</h3>
                                <h4 class="grey--text font-weight-light">
                                  Unit: {{ order.priceZAR | currency }}
                                </h4>
                                <h4 class="grey--text font-weight-light">
                                  Total:
                                  {{
                                    (order.priceZAR * order.quantity) | currency
                                  }}
                                </h4>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-spacer></v-spacer>
                        </v-layout>
                      </v-card>

                      <v-card
                        hover
                        @click="
                          checkinHistory(order.id), (selectedItem = order)
                        "
                        v-else
                      >
                        <v-layout justify-left align-center wrap>
                          <v-flex xs3>
                            <v-layout justify-center align-center row>
                              <v-flex xs2 ml-2 mr-1
                                ><h3 class="grey--text font-weight-light">
                                  <span
                                    v-if="
                                      order.checkedinCount >= order.quantity
                                    "
                                    class="green--text"
                                    >{{ order.checkedinCount }}</span
                                  ><span v-else class="red--text">{{
                                    order.checkedinCount
                                  }}</span
                                  >/{{ order.quantity }}
                                </h3></v-flex
                              >
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs3
                            v-if="
                              order.type === 'Active' &&
                              order.deviceMakeModel !== null
                            "
                          >
                            <h3 class="grey--text font-weight-light">
                              {{ order.deviceMakeModel.deviceMake.name }}
                              {{ order.deviceMakeModel.name }}
                            </h3>
                          </v-flex>
                          <v-flex
                            xs3
                            v-else-if="
                              order.type === 'Passive' &&
                              order.stockType !== null &&
                              order.stockItemId !== null
                            "
                            ><h3 class="grey--text font-weight-light">
                              {{ order.stockType.name }}
                              {{ order.stockItem.name }}
                            </h3></v-flex
                          >
                          <v-flex xs4>
                            <v-layout justify-center>
                              <v-flex xs6 v-if="order.priceUSD > 0">
                                <h3 class="grey--text">USD</h3>
                                <h4 class="grey--text font-weight-light">
                                  Unit: ${{ order.priceUSD }}
                                </h4>
                                <h4 class="grey--text font-weight-light">
                                  Total: ${{ order.priceUSD * order.quantity }}
                                </h4>
                              </v-flex>
                              <v-flex xs6>
                                <h3 class="grey--text">ZAR</h3>
                                <h4 class="grey--text font-weight-light">
                                  Unit: {{ order.priceZAR | currency }}
                                </h4>
                                <h4 class="grey--text font-weight-light">
                                  Total:
                                  {{
                                    (order.priceZAR * order.quantity) | currency
                                  }}
                                </h4>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-spacer></v-spacer>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-flex>
            <v-flex xs6 mx-1>
              <v-card>
                <v-toolbar flat color="primary">
                  <h3 class="headline white--text">Item Check-in details:</h3>
                </v-toolbar>
                <v-card-text :key="checkInItemHistory">
                  <v-flex xs12>
                    <v-layout>
                      <v-flex xs4>
                        <h3 class="grey--text">Checked-In By:</h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3
                          class="grey--text"
                          v-if="
                            checkInItemHistoryArray.length > 0 &&
                            checkInItemHistoryArray[0].ponMac === null
                          "
                        >
                          Quantity:
                        </h3>
                        <h3
                          class="grey--text"
                          v-else-if="checkInItemHistoryArray.length > 0"
                        >
                          Pon Mac:
                        </h3>
                        <h3 class="grey--text" v-else>Quantity:</h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 class="grey--text">Date:</h3>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    xs12
                    v-for="history in checkInItemHistoryArray"
                    :key="history.id"
                  >
                    <v-layout v-if="history.ponMac !== null">
                      <v-flex xs4>
                        <h3 class="grey--text font-weight-light">
                          {{ history.contact.name }}
                          {{ history.contact.surname }}
                        </h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 class="grey--text font-weight-light">
                          {{ history.ponMac }}
                        </h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 class="grey--text font-weight-light">
                          {{ formatDate(history.createdAt) }}
                        </h3>
                      </v-flex>
                    </v-layout>
                    <v-layout v-else>
                      <v-flex xs4>
                        <h3 class="grey--text font-weight-light">
                          {{ history.contact.name }}
                          {{ history.contact.surname }}
                        </h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 class="grey--text font-weight-light">
                          {{ history.count }}
                        </h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 class="grey--text font-weight-light">
                          {{ formatDate(history.createdAt) }}
                        </h3>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
           
          </v-layout>
          <v-layout>
              <v-flex xs6 mx-1>
              <v-card>
                <v-toolbar flat color="primary">
                  <h3 class="headline white--text">Order details:</h3>
                </v-toolbar>
                <v-card-text >
                  <v-flex xs12>
                    <v-layout>
                      <v-flex xs4>
                        <h3 class="grey--text">Supplier</h3> 
                      </v-flex>
                      <v-flex xs4>
                        <h3
                          class="grey--text"
                        >
                          Purchase Order
                        </h3>
                      </v-flex>
                        <v-flex xs4>
                        <h3
                          class="grey--text"
                        >
                          Order Date
                        </h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 class="grey--text">ETA</h3>
                      </v-flex>
                         <v-flex xs4>
                        <h3
                          class="grey--text"
                        >
                         Courier
                        </h3>
                         </v-flex>
                         <v-flex xs4>
                        <h3
                          class="grey--text"
                        >
                         Tracking No.
                        </h3>
                         </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    xs12
                  >
                    <v-layout >
                      <v-flex xs4>
                        <h3 class="grey--text font-weight-light">
                          {{ item.supplierOrganisation.name }}
                        </h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 class="grey--text font-weight-light">
                          {{ item.purchaseOrderNo }}
                        </h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 class="grey--text font-weight-light">
                          {{ formatDate(item.orderDate) }}
                        </h3>
                      </v-flex>
                       <v-flex xs4>
                        <h3 v-if="item.expectedArrivalDate" class="grey--text font-weight-light">
                          {{ formatDate(item.expectedArrivalDate) }}
                        </h3> <h3 v-else class="grey--text font-weight-light">
                        </h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 v-if="item.courier&&item.courier!='NULL'" class="grey--text font-weight-light">
                          {{ item.courier }}
                        </h3><h3 v-else class="grey--text font-weight-light">
                        </h3>
                      </v-flex>
                      <v-flex xs4>
                        <h3 v-if="item.trackingNo&&item.trackingNo!='NULL'" class="grey--text font-weight-light">
                          {{ item.trackingNo }}
                        </h3><h3 v-else class="grey--text font-weight-light">
                        </h3>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
              </v-flex>
            </v-layout>
      </div>
       <div v-if="activeTab==='addModal'">
          <v-toolbar flat color="white">
                <h1 :style="{ color: $store.state.currentOrg.org.primaryColour}">ADD ORDER</h1>
                <v-spacer></v-spacer>
                <v-btn
              flat
              v-if="
                item.supplierOrganisationId &&
                item.purchaseOrderNo &&
                item.orderDate
              "
              @click="saveOrder"
              >Save</v-btn
            >
            <v-btn flat v-else disabled>Save</v-btn>
                <v-btn flat @click="closeView()">Close</v-btn>
            </v-toolbar>
            <v-layout align-top justify-center>
        <v-card flat color="white">
          <v-card-text>
              <v-layout class="justify-center align-center">
              <v-flex xs2 mx-1>
                <v-autocomplete
                  v-model="item.supplierOrganisationId"
                  :items="suppliers"
                  label="*Supplier"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-flex> 
              <v-flex xs2 mx-1
                ><v-text-field
                  label="*Purchase Order"
                  v-model="item.purchaseOrderNo"
                ></v-text-field
              ></v-flex>
              <v-flex xs2 mx-1>
                 <VueCtkDateTimePicker
                label="*Order Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="item.orderDate"
              />
                <!-- <v-menu :close-on-content-click="true">
                  <v-text-field
                    :value="formatDate(this.item.orderDate)"
                    slot="activator"
                    label="*Order Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="item.orderDate"></v-date-picker>
                </v-menu> -->
              </v-flex>
              <v-flex xs2 mx-1>
                <VueCtkDateTimePicker
                label="ETA"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="item.expectedArrivalDate"
              />
              </v-flex>
              <v-flex xs2 mx-1>
                <v-autocomplete
                  :items="couriers"
                  label="Courier"
                  v-model="item.courier"
                  item-text="name"
                  item-value="name"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs2 mx-1
                ><v-text-field
                  label="Tracking No."
                  v-model="item.trackingNo"
                ></v-text-field
              ></v-flex>
              </v-layout>
              <v-layout class="justify-center align-center">
              <v-flex xs7 mx-1>
                <v-card>
                  <v-toolbar color="primary">
                    <h3 class="subheading white--text">Order Items:</h3>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="addOrderItem = true"
                      ><v-icon color="white">add_circle_outline</v-icon></v-btn
                    >
                  </v-toolbar>
                  <v-card-text :key="stockOrderListKey">
                    <v-flex
                      xs12
                      v-if="
                        typeof item.stockOrderItems === 'undefined' ||
                        item.stockOrderItems.length === 0
                      "
                    >
                      <h3 class="grey--text font-weight-light">
                        No Order Items Added.
                      </h3>
                    </v-flex>
                    <v-flex
                      xs12
                      my-1
                      v-for="(order) in item.stockOrderItems"
                      :key="order.stockItemId"
                    >
                      <!-- <v-flex xs12> -->
                      <v-card hover>
                        <v-layout justify-left align-center wrap>
                          <v-flex xs3>
                            <v-layout justify-center align-center row>
                              <v-flex xs1
                                ><v-icon
                                  color="red"
                                  @click="removeQuantity(order)"
                                  >remove_circle_icon</v-icon
                                ></v-flex
                              >
                              <v-flex xs2 ml-2 mr-1
                                ><h3 class="grey--text font-weight-light">
                                  {{ order.quantity }}
                                </h3></v-flex
                              >
                              <v-flex xs1
                                ><v-icon
                                  color="light-green"
                                  @click="addQuantity(order)"
                                  >add_circle_icon</v-icon
                                ></v-flex
                              >
                            </v-layout>
                          </v-flex>
                          <v-flex xs3>
                            <h3
                              class="grey--text font-weight-light"
                              v-if="
                                order.deviceMakeModelId !== null &&
                                typeof order.deviceMakeModel !== 'undefined'
                              "
                            >
                              {{ order.deviceMakeModel.deviceMake.name }}
                              {{ order.deviceMakeModel.name }}
                            </h3>
                            <h3
                              class="grey--text font-weight-light"
                              v-if="
                                order.stockItem !== null &&
                                typeof order.stockItem !== 'undefined' &&
                                typeof order.stockType !== 'undefined' &&
                                order.stockType !== null
                              "
                            >
                              {{ order.stockType.name }}
                              {{ order.stockItem.name }}
                            </h3>
                          </v-flex>
                          <v-flex xs4>
                            <v-layout justify-center>
                              <v-flex xs6 v-if="order.priceUSD > 0">
                                <h3 class="grey--text">USD</h3>
                                <h4 class="grey--text font-weight-light">
                                  Unit: ${{ order.priceUSD }}
                                </h4>
                                <h4 class="grey--text font-weight-light">
                                  Total: ${{ order.priceUSD * order.quantity }}
                                </h4>
                              </v-flex>
                              <v-flex xs6>
                                <h3 class="grey--text">ZAR</h3>
                                <h4 class="grey--text font-weight-light">
                                  Unit: {{ order.priceZAR | currency }}
                                </h4>
                                <h4 class="grey--text font-weight-light">
                                  Total:
                                  {{
                                    (order.priceZAR * order.quantity) | currency
                                  }}
                                </h4>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex xs2>
                            <v-layout>
                              <v-icon
                                color="grey"
                                @click="editStockOrderItem(order)"
                                >edit</v-icon
                              >
                              <v-icon
                                color="grey"
                                @click="removeStockOrderItem(order)"
                                >delete</v-icon
                              >
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
              </v-layout>
              <!-- <v-flex xs5 mx-1>
              <v-card>
                test
              </v-card>
            </v-flex> -->
          </v-card-text>
        </v-card>
      </v-layout>
       </div>

      <!-- Edit Order -->
      <div v-if="activeTab==='editModal'">
          <v-toolbar flat color="white">
                <h1 :style="{ color: $store.state.currentOrg.org.primaryColour}">EDIT ORDER</h1>
                <v-spacer></v-spacer>
               <v-btn
              flat
              v-if="!item.checkinStarted && !item.isProcessed"
              @click="checkinOrder"
              >Check-in Order</v-btn
            >
            <v-btn
              flat
              v-if="item.checkinStarted && !item.isProcessed"
              @click="checkinOrder"
              >Continue Order Check-in</v-btn
            >
            <v-btn
              flat
              v-if="
                item.supplierOrganisationId &&
                item.purchaseOrderNo &&
                item.orderDate
              "
              @click="saveEditedOrder"
              >Save</v-btn
            >
            <v-btn flat v-else disabled>Save</v-btn>
            <v-btn
              large
              flat
              @click="activeTab = 'landingPage';setActiveTabName('openOrders'); (item = {})"
              >X</v-btn
            >
            </v-toolbar>
            <v-layout align-top justify-center>
        <v-card flat color="white">
       
          <v-card-text>
            <v-layout class="justify-center align-center" >
              <v-flex xs2 mx-1>
                <v-autocomplete
                  v-model="item.supplierOrganisationId"
                  :items="suppliers"
                  label="*Supplier"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs2 mx-1
                ><v-text-field
                  label="*Purchase Order"
                  v-model="item.purchaseOrderNo"
                ></v-text-field
              ></v-flex>
              <v-flex xs2 mx-1>
                <VueCtkDateTimePicker
                label="*Order Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="item.orderDate"
              />
              </v-flex>
              <v-flex xs2 mx-1>
                <VueCtkDateTimePicker
                label="ETA"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="item.expectedArrivalDate"
              />
              </v-flex>
              <!-- <v-flex xs2 ><v-text-field label="Courier" v-model="item.courier"></v-text-field></v-flex> -->
              <v-flex xs2 mx-1>
                <v-autocomplete
                  :items="couriers"
                  label="Courier"
                  v-model="item.courier"
                  item-text="name"
                  item-value="name"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs2 mx-1
                ><v-text-field
                  label="Tracking No."
                  v-model="item.trackingNo"
                ></v-text-field
              ></v-flex>
              </v-layout>
              <v-layout class="justify-center align-center">
              <v-flex xs7 mx-1>
                <v-card>
                  <v-toolbar color="primary">
                    <h3 class="subheading white--text">Order Items:</h3>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="addOrderItem = true"
                      ><v-icon color="white">add_circle_outline</v-icon></v-btn
                    >
                  </v-toolbar>
                  <v-card-text :key="stockOrderListKey">
                    <v-flex
                      xs12
                      v-if="
                        typeof item.stockOrderItems === 'undefined' ||
                        item.stockOrderItems.length === 0
                      "
                    >
                      <h3 class="grey--text font-weight-light">
                        No Order Items Added.
                      </h3>
                    </v-flex>
                    <v-flex
                      xs12
                      my-1
                      v-for="order in item.stockOrderItems"
                      :key="order.stockItemId"
                    >
                      <!-- <v-flex xs12> -->
                      <v-card hover>
                        <v-layout justify-left align-center wrap>
                          <v-flex xs3>
                            <v-layout justify-center align-center row>
                              <v-flex xs1
                                ><v-icon
                                  v-if="order.quantity > 0"
                                  color="red"
                                  @click="removeQuantity(order)"
                                  >remove_circle_icon</v-icon
                                >
                                <v-icon v-else color="grey"
                                  >remove_circle_icon</v-icon
                                ></v-flex
                              >
                              <v-flex xs2 ml-2 mr-1
                                ><h3 class="grey--text font-weight-light">
                                  {{ order.quantity }}
                                </h3></v-flex
                              >
                              <v-flex xs1
                                ><v-icon
                                  color="light-green"
                                  @click="addQuantity(order)"
                                  >add_circle_icon</v-icon
                                ></v-flex
                              >
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs3
                            v-if="
                              order.type === 'Active' &&
                              order.deviceMakeModel !== null &&
                              typeof order.deviceMakeModel !== 'undefined'
                            "
                          >
                            <h3 class="grey--text font-weight-light">
                              {{ order.deviceMakeModel.deviceMake.name }}
                              {{ order.deviceMakeModel.name }}
                            </h3>
                          </v-flex>
                          <v-flex
                            xs3
                            v-else-if="
                              order.type === 'Passive' &&
                              order.stockType !== null &&
                              order.stockItemId !== null
                            "
                            ><h3 class="grey--text font-weight-light">
                              {{ order.stockType.name }}
                              {{ order.stockItem.name }}
                            </h3></v-flex
                          >
                          <v-flex xs4>
                            <v-layout justify-center>
                              <v-flex xs6 v-if="order.priceUSD > 0">
                                <h3 class="grey--text">USD</h3>
                                <h4 class="grey--text font-weight-light">
                                  Unit: ${{ order.priceUSD }}
                                </h4>
                                <h4 class="grey--text font-weight-light">
                                  Total: ${{ order.priceUSD * order.quantity }}
                                </h4>
                              </v-flex>
                              <v-flex xs6>
                                <h3 class="grey--text">ZAR</h3>
                                <h4 class="grey--text font-weight-light">
                                  Unit: {{ order.priceZAR | currency }}
                                </h4>
                                <h4 class="grey--text font-weight-light">
                                  Total:
                                  {{
                                    (order.priceZAR * order.quantity) | currency
                                  }}
                                </h4>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex xs2>
                            <v-layout>
                              <v-icon
                                color="grey"
                                @click="editStockOrderItem(order)"
                                >edit</v-icon
                              >
                              <v-icon
                                color="grey"
                                @click="removeStockOrderItem(order)"
                                >delete</v-icon
                              >
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs4 mt-1 v-if="item.checkpoints">
                <v-card>
                  <v-toolbar flat color="primary">
                    <h3 class="subheading white--text">Tracking History:</h3>
                  </v-toolbar>
                  <v-card-text>
                    <v-flex xs12>
                      <v-layout>
                        <v-flex xs4 class="grey--text font-weight-bold"
                          >Timestamp:</v-flex
                        >
                        <v-flex xs8 class="grey--text font-weight-bold"
                          >Message:</v-flex
                        >
                      </v-layout>
                    </v-flex>
                    <v-flex
                      xs12
                      v-for="check in item.checkpoints"
                      :key="check.subtag"
                    >
                      <v-layout justify-left>
                        <v-flex xs4 class="grey--text font-weight-light">{{
                          formatDate(check.checkpoint_time)
                        }}</v-flex>
                        <v-flex xs8 class="grey--text font-weight-light">{{
                          check.message
                        }}</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
            </v-layout>
      </div>

      <!-- Add Order Item -->
   <!-- Add Order Item -->
      <v-dialog persistent v-model="addOrderItem" max-width="1200px">
        <v-card flat color="white">
          <v-toolbar color="primary">
            <h1 class="headline white--text">ADD ORDER ITEM</h1>
          </v-toolbar>
          <v-card-text>
            <v-layout class="justify-center align-center" wrap>
              <v-flex xs3 mx-4
                ><v-select
                  v-model="orderItem.type"
                  :items="orderItemTypes"
                  label="Type of Item"
                ></v-select
              ></v-flex>
              <v-flex xs3 mx-4
                ><v-select
                  v-model="orderType"
                  :items="orderTypes"
                  label="Type of Order"
                ></v-select
              ></v-flex>
              <v-flex xs3 mx-2 v-if="orderItem.type === 'Active'"
                ><v-autocomplete
                  :items="devicemakemodels"
                  label="*Device Make & Model"
                  v-model="orderItem.deviceMakeModelId"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete
              ></v-flex>
              <v-flex xs3 v-if="orderItem.type === 'Passive'"
                ><v-autocomplete
                  :items="stocktypes"
                  v-model="orderItem.stockTypeId"
                  label="*Inventory Type"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete
              ></v-flex>
              <v-flex xs3 v-if="orderItem.type === 'Passive'"
                ><v-autocomplete
                  :items="stockitems"
                  v-model="orderItem.stockItemId"
                  label="*Inventory Item"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete
              ></v-flex>
              <v-flex
                xs2
                mx-2
                v-if="
                  (orderItem.type === 'Active' &&
                    orderItem.deviceMakeModelId) ||
                  (orderItem.type === 'Passive' &&
                    orderItem.stockTypeId &&
                    orderItem.stockItemId)
                "
                ><v-text-field
                  label="Quantity"
                  type="number"
                  v-model="orderItem.quantity"
                ></v-text-field
              ></v-flex>
              <v-flex
                xs2
                mx-2
                v-if="
                  orderType === 'Foreign Import' &&
                  ((orderItem.type === 'Active' &&
                    orderItem.deviceMakeModelId) ||
                    (orderItem.type === 'Passive' &&
                      orderItem.stockTypeId &&
                      orderItem.stockItemId))
                "
                ><v-text-field
                  label="Unit Price USD"
                  v-model="orderItem.priceUSD"
                ></v-text-field
              ></v-flex>
              <v-flex
                xs2
                mx-2
                v-if="
                  orderType === 'Foreign Import' &&
                  ((orderItem.type === 'Active' &&
                    orderItem.deviceMakeModelId) ||
                    (orderItem.type === 'Passive' &&
                      orderItem.stockTypeId &&
                      orderItem.stockItemId))
                "
                ><v-text-field
                  label="Rate Of Exchange"
                  v-model="orderItem.rateOfExchange"
                ></v-text-field
              ></v-flex>
              <v-flex
                xs2
                mx-2
                v-else-if="
                  (orderType === 'Local' &&
                    orderItem.type === 'Active' &&
                    orderItem.deviceMakeModelId) ||
                  (orderItem.type === 'Passive' &&
                    orderItem.stockTypeId &&
                    orderItem.stockItemId)
                "
                ><v-text-field
                  label="Unit Price ZAR"
                  v-model="orderItem.priceZAR"
                ></v-text-field
              ></v-flex>
              <v-flex xs12>
                <v-layout justify-center>
                  <v-flex
                    xs3
                    v-if="
                      (orderType === 'Foreign Import' &&
                        orderItem.type === 'Active' &&
                        orderItem.deviceMakeModelId) ||
                      (orderItem.type === 'Passive' &&
                        orderItem.stockTypeId &&
                        orderItem.stockItemId &&
                        orderItem.priceUSD &&
                        orderItem.rateOfExchange)
                    "
                    ><h4 label="Unit Price ZAR">
                      Unit Price ZAR:
                      {{
                        (orderItem.priceUSD * orderItem.rateOfExchange)
                          | currency
                      }}
                    </h4></v-flex
                  >
                  <v-flex
                    xs3
                    v-if="
                      orderType === 'Foreign Import' &&
                      orderItem.priceUSD > 0 &&
                      orderItem.quantity > 0
                    "
                    ><h4>
                      Total USD: ${{ orderItem.priceUSD * orderItem.quantity }}
                    </h4></v-flex
                  >
                  <v-flex
                    xs3
                    v-if="orderItem.priceZAR > 0 && orderItem.quantity > 0"
                    ><h4>
                      Total ZAR:
                      {{ (orderItem.priceZAR * orderItem.quantity) | currency }}
                    </h4></v-flex
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                round
                color="primary"
                @click="(addOrderItem = false), (orderItem = {})"
                >Cancel</v-btn
              >
              <v-btn
                round
                v-if="
                  orderItem.type === 'Active' &&
                  orderItem.deviceMakeModelId &&
                  orderItem.quantity &&
                  (orderItem.priceUSD || orderItem.priceZAR)
                "
                color="primary"
                @click="addOrderItemToList()"
                >Save</v-btn
              >
              <v-btn
                round
                v-else-if="
                  orderItem.type === 'Passive' &&
                  orderItem.stockTypeId &&
                  orderItem.stockItemId &&
                  orderItem.quantity &&
                  (orderItem.priceUSD || orderItem.priceZAR)
                "
                color="primary"
                @click="addOrderItemToList()"
                >Save</v-btn
              >
              <v-btn round disabled v-else>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="editStockOrderItemModal" max-width="1200px">
        <v-card flat color="white">
          <v-toolbar color="primary">
            <h1 class="headline white--text">EDIT ORDER ITEM</h1>
          </v-toolbar>
          <v-card-text>
            <v-layout class="justify-center align-center" wrap>
              <v-flex xs3 mx-4
                ><v-select
                  v-model="orderItem.type"
                  :items="orderItemTypes"
                  label="Type of Item"
                ></v-select
              ></v-flex>
              <v-flex xs3 mx-4
                ><v-select
                  v-model="orderType"
                  :items="orderTypes"
                  label="Type of Order"
                ></v-select
              ></v-flex>
              <v-flex xs3 mx-2 v-if="orderItem.type === 'Active'"
                ><v-autocomplete
                  :items="devicemakemodels"
                  label="*Device Make & Model"
                  v-model="orderItem.deviceMakeModelId"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete
              ></v-flex>
              <v-flex xs3 v-if="orderItem.type === 'Passive'"
                ><v-autocomplete
                  :items="stocktypes"
                  v-model="orderItem.stockTypeId"
                  label="*Inventory Type"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete
              ></v-flex>
              <v-flex xs3 v-if="orderItem.type === 'Passive'"
                ><v-autocomplete
                  :items="stockitems"
                  v-model="orderItem.stockItemId"
                  label="*Inventory Item"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete
              ></v-flex>
              <v-flex
                xs2
                mx-2
                v-if="
                  (orderItem.type === 'Active' &&
                    orderItem.deviceMakeModelId) ||
                  (orderItem.type === 'Passive' &&
                    orderItem.stockTypeId &&
                    orderItem.stockItemId)
                "
                ><v-text-field
                  label="Quantity"
                  type="number"
                  v-model="orderItem.quantity"
                ></v-text-field
              ></v-flex>
              <v-flex
                xs2
                mx-2
                v-if="
                  orderType === 'Foreign Import' &&
                  ((orderItem.type === 'Active' &&
                    orderItem.deviceMakeModelId) ||
                    (orderItem.type === 'Passive' &&
                      orderItem.stockTypeId &&
                      orderItem.stockItemId))
                "
                ><v-text-field
                  label="Unit Price USD"
                  v-model="orderItem.priceUSD"
                ></v-text-field
              ></v-flex>
              <v-flex
                xs2
                mx-2
                v-if="
                  orderType === 'Foreign Import' &&
                  ((orderItem.type === 'Active' &&
                    orderItem.deviceMakeModelId) ||
                    (orderItem.type === 'Passive' &&
                      orderItem.stockTypeId &&
                      orderItem.stockItemId))
                "
                ><v-text-field
                  label="Rate Of Exchange"
                  v-model="orderItem.rateOfExchange"
                ></v-text-field
              ></v-flex>
              <v-flex
                xs2
                mx-2
                v-if="
                  (orderType === 'Foreign Import' &&
                    orderItem.type === 'Active' &&
                    orderItem.deviceMakeModelId) ||
                  (orderItem.type === 'Passive' &&
                    orderItem.stockTypeId &&
                    orderItem.stockItemId &&
                    orderItem.priceUSD &&
                    orderItem.rateOfExchange)
                "
                ><span label="Unit Price ZAR"
                  >Unit Price ZAR:
                  {{
                    (orderItem.priceUSD * orderItem.rateOfExchange) | currency
                  }}</span
                ></v-flex
              >
              <v-flex
                xs2
                mx-2
                v-else-if="
                  (orderType === 'Local' &&
                    orderItem.type === 'Active' &&
                    orderItem.deviceMakeModelId) ||
                  (orderItem.type === 'Passive' &&
                    orderItem.stockTypeId &&
                    orderItem.stockItemId)
                "
                ><v-text-field
                  label="Unit Price ZAR"
                  v-model="orderItem.priceZAR"
                ></v-text-field
              ></v-flex>
              <v-flex xs12>
                <v-layout justify-center>
                  <v-flex
                    xs3
                    v-if="
                      orderType === 'Foreign Import' &&
                      orderItem.priceUSD > 0 &&
                      orderItem.quantity > 0
                    "
                    ><h4>
                      Total USD: ${{ orderItem.priceUSD * orderItem.quantity }}
                    </h4></v-flex
                  >
                  <v-flex
                    xs3
                    v-if="orderItem.priceZAR > 0 && orderItem.quantity > 0"
                    ><h4>
                      Total ZAR:
                      {{ (orderItem.priceZAR * orderItem.quantity) | currency }}
                    </h4></v-flex
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                round
                color="primary"
                @click="(editStockOrderItemModal = false), (orderItem = {})"
                >Cancel</v-btn
              >
              <v-btn
                round
                v-if="
                  orderItem.type === 'Active' &&
                  orderItem.deviceMakeModelId &&
                  orderItem.quantity &&
                  (orderItem.priceUSD || orderItem.priceZAR)
                "
                color="primary"
                @click="saveEditedItem()"
                >Save</v-btn
              >
              <v-btn
                round
                v-else-if="
                  orderItem.type === 'Passive' &&
                  orderItem.stockTypeId &&
                  orderItem.stockItemId &&
                  orderItem.quantity &&
                  (orderItem.priceUSD || orderItem.priceZAR)
                "
                color="primary"
                @click="saveEditedItem()"
                >Save</v-btn
              >
              <v-btn round disabled v-else>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

     <div v-if="activeTab==='checkinModal'&& item !== null &&  item.supplierOrganisation">
          <v-toolbar flat color="white">
                <h1 :style="{ color: $store.state.currentOrg.org.primaryColour}">
              CHECK-IN ORDER:
              <span class="font-weight-light"
                >{{ item.supplierOrganisation.name }} || PO/INV:
                {{ item.purchaseOrderNo }} || {{ item.courier }}:
                {{ item.trackingNo }}</span
              >
            </h1>
            <v-spacer></v-spacer>
            <v-btn
              flat
              v-if="checkedInItems.length > 0 
              && checkedInItems.filter(x => x.stockWarehouseId != null && x.stockWarehouseId != 'undefined').length == checkedInItems.length"
              @click="submitCheckin()"
              >Submit Check-in</v-btn
            >
            <v-btn
              flat
              v-if="
                item.supplierOrganisationId &&
                item.purchaseOrderNo &&
                item.orderDate 
                && checkedInItems.filter(x => x.stockWarehouseId != null && x.stockWarehouseId != 'undefined').length == checkedInItems.length"
              
              @click="saveCheckInOrder"
              >Save</v-btn
            >
            <v-btn flat  v-else disabled>Save</v-btn>
            <v-btn large flat @click="activeTab = 'landingPage'; setActiveTabName('openOrders')"
              >X</v-btn
            >
            </v-toolbar>
            <v-layout align-top justify-center>       
    <v-flex xs12>
        <v-card flat color="white">
          <v-card-text>
            <v-layout>
              <v-flex xs6 ma-1>
                <v-card>
                  <v-toolbar color="primary" flat>
                    <h3 class="headline white--text">Ordered Items:</h3>
                  </v-toolbar>
                  <v-layout justify-center align-left wrap>
                    <v-flex
                      xs12
                      ma-1
                      v-for="order in item.stockOrderItems"
                      :key="order.id"
                    >
                      <v-flex xs12>
                        <v-layout justify-left>
                          <v-flex xs6 :key="checkinCountUpdateKey">
                            <h4 class="grey--text">
                              <span
                                v-if="checkedInQuantity(order) < order.quantity"
                                class="red--text"
                                >{{ checkedInQuantity(order) }}</span
                              ><span v-else class="green--text">{{
                                checkedInQuantity(order)
                              }}</span
                              >/{{ order.quantity }}
                            </h4>
                          </v-flex>
                          <v-flex
                            xs6
                            v-if="
                              order.type === 'Active' &&
                              order.deviceMakeModel !== null &&
                              typeof order.deviceMakeModel !== 'undefined'
                            "
                          >
                            <h3 class="grey--text font-weight-light">
                              {{ order.deviceMakeModel.deviceMake.name }}
                              {{ order.deviceMakeModel.name }}
                            </h3>
                          </v-flex>
                          <v-flex
                            xs6
                            v-else-if="
                              order.type === 'Passive' &&
                              order.stockType !== null &&
                              order.stockItemId !== null
                            "
                            ><h3 class="grey--text font-weight-light">
                              {{ order.stockType.name }}
                              {{ order.stockItem.name }}
                            </h3></v-flex
                          >
                          <v-flex xs3>
                            <v-icon
                              color="grey"
                              @click="
                                checkedInItems.push({
                                  id: (checkedId += 1),
                                  stockOrderItemId: order.id,
                                  stockOrderItem: order,
                                  scannedItems: [],
                                  count: 0,
                                  isUpload: false,
                                })
                              "
                              >forward</v-icon
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs6 ma-1>
                <v-card>
                  <v-toolbar color="primary" flat>
                    <h3 class="headline white--text">Checked-In Items:</h3>
                  </v-toolbar>
                  <v-layout justify-center align-center wrap>
                    <v-flex
                      xs12
                      ma-1
                      v-for="checkedItem in checkedInItems"
                      :key="checkedItem.id"
                    >
                      <v-card flat>
                        <v-layout justify-left align-center wrap>
                          <v-flex xs3>
                            <v-layout
                              justify-center
                              align-center
                              row
                              v-if="
                                checkedItem.stockOrderItem.type === 'Passive'
                              "
                            >
                              <v-flex xs1
                                ><v-icon
                                  color="red"
                                  v-if="checkedItem.count > 0"
                                  @click="checkedItem.count -= 1"
                                  >remove_circle_icon</v-icon
                                >
                                <v-icon color="grey" v-else
                                  >remove_circle_icon</v-icon
                                ></v-flex
                              >
                              <v-flex xs6 ml-2 mr-1
                                ><v-text-field
                                  class="centered-input"
                                  v-model="checkedItem.count"
                                  dense
                                  outlined
                                  type="number"
                                ></v-text-field
                              ></v-flex>
                              <v-flex xs1
                                ><v-icon
                                  color="light-green"
                                  @click="checkedItem.count += 1"
                                  >add_circle_icon</v-icon
                                ></v-flex
                              >
                            </v-layout>
                            <v-layout justify-center align-center row v-else>
                              <v-flex xs6 ml-2 mr-1
                                ><h3 class="grey--text">
                                  {{ checkedItem.count }}
                                </h3></v-flex
                              >
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs4
                            v-if="
                              checkedItem.stockOrderItem.type === 'Active' &&
                              checkedItem.stockOrderItem.deviceMakeModel !==
                                null
                            "
                          >
                            <h3 class="grey--text font-weight-light">
                              {{
                                checkedItem.stockOrderItem.deviceMakeModel
                                  .deviceMake.name
                              }}
                              {{
                                checkedItem.stockOrderItem.deviceMakeModel.name
                              }}
                            </h3>
                          </v-flex>
                          <v-flex
                            xs4
                            v-else-if="
                              checkedItem.stockOrderItem.type === 'Passive' &&
                              checkedItem.stockOrderItem.stockType !== null &&
                              checkedItem.stockOrderItem.stockItemId !== null
                            "
                            ><h3 class="grey--text font-weight-light">
                              {{ checkedItem.stockOrderItem.stockType.name }}
                              {{ checkedItem.stockOrderItem.stockItem.name }}
                            </h3></v-flex
                          >
                          <v-flex xs3>
                            <v-autocomplete
                              :items="warehouses"
                              label="*Warehouse"
                              item-text="name"
                              item-value="id"
                              v-model="checkedItem.stockWarehouseId"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs1>
                            <v-icon
                              color="grey"
                              @click="
                                checkedInItems.splice(
                                  checkedInItems.indexOf(checkedItem),
                                  1
                                )
                              "
                              >delete</v-icon
                            >
                            <v-tooltip
                              top
                              v-if="
                                checkedItem.stockOrderItem.type === 'Active'
                              "
                            >
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  v-if="!checkedItem.isUpload"
                                  color="grey"
                                  @click="
                                    (checkedItem.isUpload = true),
                                      applyCSVItem(checkedItem),
                                      (activeTab='csvCheckInModal')
                                  "
                                  >cloud_upload</v-icon
                                >
                                <v-icon
                                  v-on="on"
                                  v-else
                                  color="blue"
                                  @click="
                                    applyCSVItem(checkedItem),
                                      (activeTab='csvCheckInModal')
                                  "
                                  >cloud_upload</v-icon
                                >
                              </template>
                              <span>Check-In with CSV Import</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
    </v-flex>
            </v-layout>
     </div>


          <div v-if="activeTab==='csvCheckInModal'&& csvCheckInItem">
          <v-toolbar flat color="white">
                <h1 :style="{ color: $store.state.currentOrg.org.primaryColour}">
              Checkin by CSV upload</h1>
              <v-spacer></v-spacer>
               <v-btn
              flat
              @click="
                activeTab = 'checkinModal';
                csvCheckInItem = {};
              "
              >Done</v-btn
            >
            <v-btn
              flat
              @click="
                activeTab = 'landingPage';
                csvCheckInItem = {};
              "
              >X</v-btn
            >
            </v-toolbar>
            <v-layout align-top justify-center>    
       
        <v-card flat>
          <v-card-text>
            <bulkupload
              v-if="csvCheckInItem"
              :headers="testHeader"
              :checkinitem="csvCheckInItem"
              @scannedItemsChange="scannedItemsChange"
            />
          </v-card-text>
        </v-card>
            </v-layout>
          </div>
    
   
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import bulkUpload from "@/components/checkInUpload";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  props: [
    "stockorders",
    "suppliers",
    "devicemakemodels",
    "stocktypes",
    "stockitems",
    "couriers",
    "warehouses",
  ],
  components: {
    bulkupload: bulkUpload,
      VueCtkDateTimePicker: VueCtkDateTimePicker,
  },
  data() {
    return {
      activeTab: 'landingPage',
      addOrder: false,
      editOrder: false,
      addOrderItem: false,
      foreignImport: false,
      editStockOrderItemModal: false,
      checkinModal: false,
      editedItem: {},
      csvCheckInModal: false,
      viewProcessedOrder: false,
      csvCheckInItem: {},
      editedIndex: null,
      stockOrderListKey: 0,
      checkedInItems: [],
      processedCheckInItems: [],
      checkedId: 0,
      checkInItemHistory: null,
      selectedItem: {},
      checkInItemHistoryArray: [],
      testHeader: [{ text: "ponMac", align: "center" }],
      orderType: "Local",
      orderTypes: ["Local", "Foreign Import"],
      search: "",
      item: {},
      orderItem: {},
      activeTabName: "",
      orderItemTypes: ["Active", "Passive"],
      checkinCountUpdateKey: 0,
      tabs: [
        { name: "openOrders", displayName: "Open Orders" },
        { name: "processedOrders", displayName: "Processed Orders" },
      ],
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Order Date",
          align: "center",
          value: "orderDate",
        },
        {
          text: "Delivery Date",
          align: "center",
          value: "expectedArrivalDate",
        },
        {
          text: "Supplier",
          align: "center",
          value: "supplierOrganisation.name",
        },
        {
          text: "PO/INV Number",
          align: "center",
          value: "purchaseOrderNumber",
        },
        {
          text: "Courier",
          align: "center",
          value: "courier",
        },
        {
          text: "Tracking No.",
          align: "center",
          value: "trackingNo",
        },
        {
          text: "Delivery Status",
          align: "center",
          value: "orderStatus",
        },
      ],
      processedHeaders: [
        {
          text: "Order Date",
          align: "center",
          value: "orderDate",
        },
        {
          text: "Delivery Date",
          align: "center",
          value: "expectedArrivalDate",
        },
        {
          text: "Check-in Date",
          align: "center",
          value: "checkInDate",
        },
        {
          text: "Supplier",
          align: "center",
          value: "supplierOrganisation.name",
        },
        {
          text: "PO/INV Number",
          align: "center",
          value: "purchaseOrderNumber",
        },
        {
          text: "Courier",
          align: "center",
          value: "courier",
        },
        {
          text: "Tracking No.",
          align: "center",
          value: "trackingNo",
        },
      ],
    };
  },
  watch: {
    "orderItem.stockItemId": {
      immediate: true,
      handler(value) {
        if (typeof value !== "undefined" && value !== null) {
          let item = this.stockitems.find((x) => x.id === value);
          this.orderItem.stockTypeId === item.stockTypeId;
        }
      },
    },
    "orderItem.priceUSD": {
      immediate: true,
      handler(value) {
        if (typeof value !== "undefined" && value !== null && value !== 0) {
          if (
            typeof this.orderItem.rateOfExchange !== "undefined" &&
            this.orderItem.rateOfExchange !== null
          ) {
            this.orderItem.priceZAR =
              this.orderItem.priceUSD * this.orderItem.rateOfExchange;
          } else {
            this.orderItem.priceZAR = 0;
          }
        }
      },
    },
    "orderItem.rateOfExchange": {
      immediate: true,
      handler(value) {
        if (typeof value !== "undefined" && value !== null) {
          if (
            typeof this.orderItem.priceUSD !== "undefined" &&
            this.orderItem.priceUSD !== null &&
            this.orderItem.priceUSD !== 0
          ) {
            this.orderItem.priceZAR =
              this.orderItem.priceUSD * this.orderItem.rateOfExchange;
          } else {
            this.orderItem.priceZAR = 0;
          }
        }
      },
    },
  },
  created() {
    this.setActiveTabName("openOrders");
  },
  methods: {
     closeView(){
       this.item = {}
       this.setActiveTabName("openOrders");
       this.activeTab='landingPage'
     },
    async checkinHistory(stockOrderItemId) {
      console.log('stockOrderItemId', stockOrderItemId)
      console.log('this.item.checkedInItems', this.item.checkedInItems)
      if(this.item.checkedInItems){
    let array = await this.item.checkedInItems.filter(function (el) {
        return el.stockOrderItemId === stockOrderItemId;
      });
      this.checkInItemHistoryArray = array;
      }
  
    },
    async changeViewStatus(item) {
      let index = await this.item.stockOrderItems.indexOf(item);
      this.item.stockOrderItems[index].viewMore = !this.item.stockOrderItems[
        index
      ].viewMore;
    },
    async viewItem(item) {
      this.item = Object.assign({}, item);
      this.checkedInItems = [];
      Api()
        .get("/checkinItem/byStockOrder/" + this.item.id)
        .then(async response => {
          this.item.checkedInItems = response.data;
      
      await Api()
        .get("/stockOrderItem/bystockOrder/" + this.item.id)
        .then(async (response) => {
          this.orderItem = {};
          this.item.stockOrderItems = response.data;
          await this.checkinHistory(this.item.stockOrderItems[0].id);
          this.checkInItemHistory = this.item.stockOrderItems[0].id;

          for (let a = 0; a < this.item.stockOrderItems.length; a++) {
            this.item.stockOrderItems[a].viewMore = false;
            let findId = this.item.stockOrderItems[a].id;
            let array = await this.item.checkedInItems.filter(function (el) {
              return el.stockOrderItemId === findId;
            });
            this.item.stockOrderItems[a].checkedinCount = array.reduce(
              (a, b) => +a + +b.count,
              0
            );

            if (
              typeof this.item.stockOrderItems[a].checkinItems !==
                "undefined" &&
              this.item.stockOrderItems[a].checkinItems.length > 0
            ) {
              this.item.checkinStarted = true;
              // a = this.item.stockOrderItems.length
            }
            // this.item.stockOrderItems[a].checkinItems.map(b=>{
            //   if(b.isActive&&!b.isDeleted){
            //     b.stockItem = this.item.stockOrderItems[a].stockItem
            //     b.stockType = this.item.stockOrderItems[a].stockType
            //     b.deviceMakeModel = this.item.stockOrderItems[a].deviceMakeModel
            //     this.checkedInItems.push(b)
            //   }
            // })
          }
          //this.editOrder = false;
          //this.viewProcessedOrder = true;
          console.log('ite', item)
          this.activeTab='viewProcessedOrderModal'
        });
          });
    },
    async submitCheckin() {
      await this.saveCheckInOrder();
      var passiveEquipPost = [];
      //var devicePost = [];
      // let active = await this.checkedInItems.filter(function (el) {
      //   return el.stockOrderItem.type === "Active";
      // });
      let passive = await this.checkedInItems.filter(function (el) {
        return el.stockOrderItem.type === "Passive";
      });

      var helper = {};
      var result = passive.reduce(function (r, o) {
        var key = o.stockWarehouseId + "-" + o.stockOrderItem.stockItemId;
        if (!helper[key]) {
          helper[key] = Object.assign({}, o);
          r.push(helper[key]);
        } else {
         if (o.isActive && !o.isDeleted) {
           helper[key].count += o.count;
         } 
        }
        return r;
      }, []);
      await result.map((b) => {
        passiveEquipPost.push({
          checkinItemId: b.id,
          stockItemId: b.stockOrderItem.stockItemId,
          quantity: b.count,
          stockWarehouseId: b.stockWarehouseId,
        });
      });
      // await active.map((c) => {
      //   c.scannedItems.map((d) => {
      //     devicePost.push({
      //       //checkinItemId: d.id,
      //       inStock: true,
      //       stockWarehouseId: c.stockWarehouseId,
      //       deviceMakeModelId: c.stockOrderItem.deviceMakeModelId,
      //       ponMac: d.ponMac,
      //     });
      //   });
      // });
      //devices created in checkIn post
      this.createPassiveEquipment(passiveEquipPost);
      this.updateStockOrder();
    },
    updateStockOrder() {
      Api()
        .put("/stockOrder/" + this.item.id, {
          isProcessed: true,
          checkInDate: new Date(),
        })
        .then(async (response) => {
          let obj = await this.stockorders.find((x) => x.id === this.item.id);
          let index = this.stockorders.indexOf(obj);
          this.stockorders[index].isProcessed = true;
          this.item = {};
          //this.editOrder = false;
          //this.checkinModal = false;
          this.activeTab='landingPage'
        });
    },
    createPassiveEquipment(array) {
      Api().post("/createPassiveEquipment", {
        batch: array,
      }).then(response=>{
      })
    },
    scannedItemsChange(value) {
      let index = this.checkedInItems.indexOf(this.csvCheckInItem);
      this.checkedInItems[index].count = value.length;
      this.checkedInItems[index].scannedItems = value;
    },
    applyCSVItem(item) {
      this.csvCheckInItem = item;
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    async createTrackingOrder(item) {
      let ref = await this.couriers.find((x) => x.name === item.courier);
      Api().post("/courier/createTrackingOrder", {
        tracking: {
          slug: ref.slug,
          tracking_number: item.trackingNo,
          title: item.purchaseOrderNo,
          order_id: item.id,
          language: "en",
        },
      });
    },
    async editItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.item = Object.assign({}, item);
        await Api()
          .get("/stockOrderItem/bystockOrder/" + this.item.id)
          .then((response) => {
            this.orderItem = {};
            this.item.stockOrderItems = response.data;
            for (let a = 0; a < this.item.stockOrderItems.length; a++) {
              if (
                typeof this.item.stockOrderItems[a].checkinItems !==
                  "undefined" &&
                this.item.stockOrderItems[a].checkinItems.length > 0
              ) {
                this.item.checkinStarted = true;
                a = this.item.stockOrderItems.length;
              }
            }
            this.activeTab='editModal'
            //this.editOrder = true;
          });
      }
    },
    async checkinOrder() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.checkedInItems = [];
        for (let a = 0; a < this.item.stockOrderItems.length; a++) {
          if (this.item.stockOrderItems[a].checkinItems) {
            if (this.item.stockOrderItems[a].type === "Passive") {
              await this.item.stockOrderItems[a].checkinItems.map(async (b) => {
                if (b.isActive && !b.isDeleted) {
                  b.stockOrderItem = this.item.stockOrderItems[a];
                  await this.checkedInItems.push(b);
                }
              });
            } else if (this.item.stockOrderItems[a].type === "Active") {
              var helper = {};
              this.item.stockOrderItems[a].checkinItems.map((d) => {
                d.scannedItems = [];
                d.stockOrderItem = this.item.stockOrderItems[a];
                d.count = 0;
              });
              var result = this.item.stockOrderItems[a].checkinItems.reduce(
                function (r, o) {
                  var key = o.stockWarehouseId;
                  if (!helper[key]) {
                    helper[key] = Object.assign({}, o);
                    if (o.isActive && !o.isDeleted) {
                      helper[key].scannedItems.push({
                        id: o.id,
                        ponMac: o.ponMac,
                      });
                      helper[key].count += 1;
                    }
                    r.push(helper[key]);
                  } else {
                    if (o.isActive && !o.isDeleted) {
                      helper[key].count += 1;
                      helper[key].scannedItems.push({
                        id: o.id,
                        ponMac: o.ponMac,
                      });
                    }
                  }

                  return r;
                },
                []
              );
              result.map((c) => {
                this.checkedInItems.push(c);
              });
            }
          }
        }
        //this.checkinModal = true;
        this.activeTab='checkinModal'
      }
    },
    checkedInQuantity(item) {
      let id = item.id;
      let checkedIn = this.checkedInItems.filter(function (el) {
        return el.stockOrderItem.id === id;
      });
      if (checkedIn.length > 0) {
        return checkedIn.reduce((a, b) => +a + +b.count, 0);
      } else {
        return 0;
      }
    },
    addQuantity(item) {
      let index = this.item.stockOrderItems.indexOf(item);
      this.item.stockOrderItems[index].quantity = parseInt(
        this.item.stockOrderItems[index].quantity
      );
      this.item.stockOrderItems[index].quantity += 1;
    },
    removeQuantity(item) {
      let index = this.item.stockOrderItems.indexOf(item);
      this.item.stockOrderItems[index].quantity = parseInt(
        this.item.stockOrderItems[index].quantity
      );
      this.item.stockOrderItems[index].quantity -= 1;
    },
    removeStockOrderItem(item) {
      let index = this.item.stockOrderItems.indexOf(item);
      this.item.stockOrderItems.splice(index, 1);
      if (item.id) {
        Api().put("/stockOrderItem/" + item.id, {
          isActive: false,
          isDeleted: true,
        });
      }
      this.stockOrderListKey += 1;
    },
    editRemoveStockOrderItem(item) {
      let index = this.item.stockOrderItems.indexOf(item);
      this.item.stockOrderItems.splice(index, 1);
      Api().put("/stockOrderItem/" + item.id, {
        isActive: false,
        isDeleted: true,
      });
      this.stockOrderListKey += 1;
    },
    editStockOrderItem(item) {
      this.editedIndex = this.item.stockOrderItems.indexOf(item);
      this.orderItem = item;
      this.editStockOrderItemModal = true;
      // this.item.stockOrderItems.splice(index, 1)
    },
    saveEditedItem() {
      this.item.stockOrderItems[this.editedIndex] = this.orderItem;
      this.editStockOrderItemModal = false;
      this.orderItem = {};
    },
    deleteItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to delete this Inventory Item?") &&
          Api()
            .put("/stockOrder/" + item.id, {
              isActive: false,
              isDeleted: true,
            })
            .then(this.$emit("stockOrderChange"));
      }
    },
    addItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.item = {}
        this.activeTab = 'addModal';
      }
    },
    saveOrder() {
      Api()
        .post("/stockOrder", {
          supplierOrganisationId: this.item.supplierOrganisationId,
          purchaseOrderNo: this.item.purchaseOrderNo,
          orderDate: this.item.orderDate,
          expectedArrivalDate: this.item.expectedArrivalDate,
          courier: this.item.courier,
          trackingNo: this.item.trackingNo,
          isActive: true,
          isDelete: false,
        })
        .then((response) => {
          let id = response.data.id;
          // this.stockorders.push(response.data)
          let orgId = response.data.organisationId;
          if (
            response.data.courier !== null &&
            response.data.trackingNo !== null
          ) {
            this.createTrackingOrder(response.data);
          }
          if (this.item.stockOrderItems) {
          for (let i = 0; i < this.item.stockOrderItems.length; i++) {
            this.item.stockOrderItems[i].stockOrderId = id;
            this.item.stockOrderItems[i].organisationId = orgId;
          }
          }
          if (this.item.stockOrderItems) {
            Api().post("/stockOrderItem", {
              batch: this.item.stockOrderItems,
            });
          }
          //this.addOrder = false;
          this.item = {};
          this.$emit("stockOrderChange");
          this.activeTab='landingPage'
        });
    },
    saveEditedOrder() {
      Api()
        .put("/stockOrder/" + this.item.id, {
          supplierOrganisationId: this.item.supplierOrganisationId,
          purchaseOrderNo: this.item.purchaseOrderNo,
          orderDate: this.item.orderDate,
          expectedArrivalDate: this.item.expectedArrivalDate,
          courier: this.item.courier,
          trackingNo: this.item.trackingNo,
          orderStatus: this.item.orderStatus,
          isActive: true,
          isDelete: false,
        })
        .then((response) => {
          let foundItem = this.stockorders.find((x) => x.id === this.item.id);
          let stockOrderIndex = this.stockorders.indexOf(foundItem);
          this.stockorders[stockOrderIndex] = response.data;
          for (let i = 0; i < this.item.stockOrderItems.length; i++) {
            if (typeof this.item.stockOrderItems[i].id !== "undefined") {
              Api().put("/stockOrderItem/" + this.item.stockOrderItems[i].id, {
                type: this.item.stockOrderItems[i].type,
                stockTypeId: this.item.stockOrderItems[i].stockTypeId,
                deviceMakeModelId: this.item.stockOrderItems[i]
                  .deviceMakeModelId,
                quantity: this.item.stockOrderItems[i].quantity,
                priceUSD: this.item.stockOrderItems[i].priceUSD,
                priceZAR: this.item.stockOrderItems[i].priceZAR,
                rateOfExchange: this.item.stockOrderItems[i].rateOfExchange,
              });
            } else {
              Api()
                .post("/stockOrderItem", {
                  stockOrderId: this.item.id,
                  type: this.item.stockOrderItems[i].type,
                  stockTypeId: this.item.stockOrderItems[i].stockTypeId,
                  deviceMakeModelId: this.item.stockOrderItems[i]
                    .deviceMakeModelId,
                  quantity: this.item.stockOrderItems[i].quantity,
                  priceUSD: this.item.stockOrderItems[i].priceUSD,
                  priceZAR: this.item.stockOrderItems[i].priceZAR,
                  rateOfExchange: this.item.stockOrderItems[i].rateOfExchange,
                })
                .then((response) => {                  
                 // this.item.stockOrderItems.push(response.data)
                });
            }
          }

          //(this.editOrder = false),
            (this.item = {}),
            this.$emit("stockOrderChange");
            this.activeTab='landingPage'
        });
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    async createCheckinItem(array, editArray) {
      if (array.length > 0) {
        await Api().post("/createCheckinItem", {
          batch: array,
        });
      }
      editArray.map((a) => {
        Api().put("/checkinItem/" + a.id, {
          count: a.count,
          stockWarehouseId: a.stockWarehouseId,
        });
      });
      //this.checkinModal = false;
      this.activeTab='landingPage'
    },
    async saveCheckInOrder() {
      let array = [];
      var editArray = [];
      for (let i = 0; i < this.checkedInItems.length; i++) {
        if (
          typeof this.checkedInItems[i].scannedItems !== "undefined" &&
          this.checkedInItems[i].scannedItems.length > 0
        ) {
          for (let x = 0; x < this.checkedInItems[i].scannedItems.length; x++) {
            if (
              typeof this.checkedInItems[i].scannedItems[x].id === "undefined"
            ) {
              await array.push({
                stockOrderId: this.checkedInItems[i].stockOrderItem
                  .stockOrderId,
                stockItemId: this.checkedInItems[i].stockOrderItem.stockItemId,
                deviceMakeModelId: this.checkedInItems[i].stockOrderItem
                  .deviceMakeModelId,
                stockWarehouseId: this.checkedInItems[i].stockWarehouseId,
                stockOrderItemId: this.checkedInItems[i].stockOrderItemId,
                ponMac: this.checkedInItems[i].scannedItems[x].ponMac,
                count: 1,
              });
            } else {
              await editArray.push({
                id: this.checkedInItems[i].scannedItems[x].id,
                deviceMakeModelId: this.checkedInItems[i].stockOrderItem
                  .deviceMakeModelId,
                stockItemId: this.checkedInItems[i].stockOrderItem.stockItemId,
                stockOrderId: this.checkedInItems[i].stockOrderItem
                  .stockOrderId,
                stockWarehouseId: this.checkedInItems[i].stockWarehouseId,
                stockOrderItemId: this.checkedInItems[i].stockOrderItemId,
                ponMac: this.checkedInItems[i].scannedItems[x].ponMac,
                count: 1,
              });
            }
          }
        } else {
          if (
            this.checkedInItems[i].stockOrderItem.type === "Passive" &&
            typeof this.checkedInItems[i].createdAt === "undefined"
          ) {
            await array.push({
              stockItemId: this.checkedInItems[i].stockOrderItem.stockItemId,
              stockWarehouseId: this.checkedInItems[i].stockWarehouseId,
              stockOrderId: this.checkedInItems[i].stockOrderItem.stockOrderId,
              stockOrderItemId: this.checkedInItems[i].stockOrderItemId,
              count: parseInt(this.checkedInItems[i].count),
            });
          } else {
            await editArray.push({
              id: this.checkedInItems[i].id,
              count: parseInt(this.checkedInItems[i].count),
              stockOrderId: this.checkedInItems[i].id,
              stockWarehouseId: this.checkedInItems[i].stockWarehouseId,
            });
          }
        }
      }
      this.createCheckinItem(array, editArray); //creates devices
    },
    addOrderItemToList() {
      //this.orderItem.stockOrderId = this.item.id;
      if (this.orderItem.type === "Active") {
        let deviceMakeModel = this.devicemakemodels.find(
          (x) => x.id === this.orderItem.deviceMakeModelId
        );
        this.orderItem.deviceMakeModel = deviceMakeModel;
      } else if (this.orderItem.type === "Passive") {
        let stockType = this.stocktypes.find(
          (x) => x.id === this.orderItem.stockTypeId
        );
        this.orderItem.stockType = stockType;
        let stockItem = this.stockitems.find(
          (x) => x.id === this.orderItem.stockItemId
        );
        this.orderItem.stockItem = stockItem;
      }
      console.log('this.orderItem', this.orderItem)
      // Api()
      //   .post("/stockOrderItem", this.orderItem)
      //   .then((response) => {
      //     // this.item.stockOrderItems.push(this.orderItem)
      //   });
      if (typeof this.item.stockOrderItems !== "undefined") {
        this.item.stockOrderItems.push(this.orderItem);
        this.orderItem = {};
        this.addOrderItem = false;
      } else {
        this.item.stockOrderItems = [];
        this.item.stockOrderItems.push(this.orderItem);
        this.orderItem = {};
        this.addOrderItem = false;
      }
      this.stockOrderListKey += 1;
    },
  },
};
</script>

<style>
.centered-input input {
  text-align: center;
  font-size: 15px;
}
</style>